export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./by-login.vue?vue&type=template&id=a28707f0"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/registration/by-login.vue?vue&type=template&id=a28707f0
// module id = URF/
// module chunks = 0